import * as React from "react";
import { Platform } from "utils/website";
import {
	TBannerModule,
	TCountdownBannerModule,
	TIconGroupModule,
	TMagicBannerModule,
	TMagicBannerTwoModule,
	TModule,
	TModuleType,
	TPlayground,
	TMultiProductModule,
	TTextModule,
	TCouponGroupModule,
	CouponType,
} from "services/page/admin";
import { ModuleInteraction } from "services/page/common";

import { getValidModuleData, refreshModule } from "utils/playground/module";
import { sendPrmByUrl } from "utils/prm";
import {
	bannerPlaceholder,
	transformMagicLinks,
	transformNavIcons,
	tranformCouponInfo,
} from "utils/playground/banner";
import { transformBannerSize, transformBannersSize, fetchBannerGridWidth } from "../../utils";
import {
	transformProductModule,
	loadPoolByFront,
	fetchProductPosterRadio,
	placeholderGroup,
} from "utils/playground/product";
import {
	replaceUrlWithTag,
	ParseProductTagFromUrlResp,
	heightLightTabIndex,
} from "utils/playground/url";
import { getGetCoupons } from "utils/zeusFetch";
import { jumpToLogin } from "utils/url";
import { WEB_WIDTH, WEB_MINWIDTH } from "../../utils/constants";
import { ModuleLayoutStyle } from "optimus-front/lib/services/playground";

import {
	WebMagicBanner as MagicBanner,
	WebCountdownBanner as CountBanner,
	WebTypography,
	WebCardBanner as CardBanner,
	WebCarousel,
	WebNavigation,
	WebSlideProduct,
	WebNormalProduct as WebProduct,
	CouponCode,
} from "optimus-front";

import { getSite } from "utils/url";
import { sendPrm } from "tyrande/lib/prm";
import { SetLitbCtrTrackOnAction, SetLitbCtrTrackOnShow } from "utils/ctrTrack";
import { RuntimeProps } from "../../../index";
import { isUAT } from "utils/debug";
interface MainProps {
	id?: string;
	modules: TModule[];
	page: TPlayground;
	stickToTop?: number;
	tagQuery: ParseProductTagFromUrlResp;
	runtime: RuntimeProps;
}

export default class Main extends React.Component<MainProps, {}> {
	constructor(props: MainProps) {
		super(props);
		this.state = {};
	}
	// tslint:disable-next-line
	renderComponents = (item: TModule, index: number) => {
		const { header, layout, ui } = item;
		const { languageCode } = this.props.runtime;
		const positionId = header.position || `floor${index + 1}`;
		let modProps: any = {
			key: positionId,
			positionId,
			online: true,
			index,
			stickToTop: this.props.stickToTop,
			minWidth: WEB_MINWIDTH,
			width: WEB_WIDTH,
			language: languageCode,
		};

		const PrmCommonParams = {
			floor: index + 1,
			position: 1,
			platform: Platform.WEB,
		};

		const moduleData = getValidModuleData(item);
		switch (item.type) {
			case TModuleType.TNavIcons:
				let icons = (item.module as typeof item.module & TIconGroupModule).icons;
				const { navs } = transformNavIcons(icons, PrmCommonParams);
				return <WebNavigation navModules={navs} {...modProps} />;
			case TModuleType.TSwiper:
				const tBannerData: TBannerModule = moduleData;
				const tBannerItems = tBannerData.elements.reduce((result, element) => {
					const newItems = (element.items || []).map((ele) => ele);
					return [...result, ...newItems];
				}, []);

				const tBanners = transformBannersSize(tBannerItems, { ...PrmCommonParams });
				if (item.layout?.interaction !== ModuleInteraction.None) {
					return (
						<CardBanner
							{...modProps}
							cardBanners={tBanners}
							placeholderBg={bannerPlaceholder}
						/>
					);
				}
				return (
					<WebCarousel
						{...modProps}
						showArrow
						banners={tBanners}
						placeholderBg={bannerPlaceholder}
					/>
				);
			case TModuleType.TMagicBannerType:
				const magicModule: TMagicBannerModule = moduleData;
				const magicBanner = transformBannerSize(
					{ ...magicModule.banner },
					{ ...PrmCommonParams },
				);
				const magicModuleItems: any = transformMagicLinks(index, magicModule.items);
				modProps = {
					...modProps,
					width: fetchBannerGridWidth(+magicBanner.width),
				};

				return (
					<MagicBanner
						{...modProps}
						banner={magicBanner}
						onClick={sendPrmByUrl}
						placeholderBg={bannerPlaceholder}
						linkItems={magicModuleItems}
					/>
				);
			case TModuleType.TMagicBannerTwo:
				const magicTwoModule: TMagicBannerTwoModule = moduleData;
				const magicBannerTwo = transformBannerSize(
					{ ...magicTwoModule.banners[0] },
					{ ...PrmCommonParams },
				);
				const magicTwoModuleItems = transformMagicLinks(index, magicTwoModule.items);
				return (
					<MagicBanner
						{...modProps}
						banner={magicBannerTwo}
						onClick={sendPrmByUrl}
						placeholderBg={bannerPlaceholder}
						linkItems={magicTwoModuleItems}
					/>
				);
			case TModuleType.TRichText:
				const textModule = item.module as typeof item.module & TTextModule;
				return (
					<WebTypography
						{...modProps}
						bgColor={item.ui?.bgColor || "#fff"}
						content={textModule && textModule.content}
					/>
				);
			case TModuleType.TCountdownBanner:
				const countDownModule: TCountdownBannerModule = moduleData;
				const cBanner = transformBannerSize(
					{ ...countDownModule.banner },
					{ ...PrmCommonParams },
				);
				return (
					<CountBanner
						{...modProps}
						banner={cBanner as any}
						timer={countDownModule.timer as any}
						actState={countDownModule.state as any}
						onRefresh={refreshModule(item.id, {
							runtime: this.props.runtime,
						})}
						placeholderBg={bannerPlaceholder}
					/>
				);
			case TModuleType.TMultiProductModuleType:
				let productModule = item.module as typeof item.module & TMultiProductModule;
				const { tagGroup, nextItems } = transformProductModule(
					productModule.proModules,
					PrmCommonParams,
					ui,
				);
				let activeTabIndex = 0;
				const { tagQuery } = this.props;
				if (item.header?.position === tagQuery.modId) {
					activeTabIndex = heightLightTabIndex(nextItems, tagQuery.tagName) || 0;
				}
				const posterRadio = fetchProductPosterRadio(ui.shape);
				const isRollable = layout?.interaction === ModuleInteraction.RollOver;
				modProps = {
					...modProps,
					isRollable,
					posterRadio,
					productModules: nextItems,
					tagGroup,
					placeholderBg: placeholderGroup(ui.shape),
					layoutStyle: ModuleLayoutStyle.Tomato,
					canScrollFixed: true,
					notUseQnparams: true,
					activeTab: nextItems[activeTabIndex].poolId,
					layout: { ...layout, columnNum: Math.max(layout.columnNum, 5), gap: 10 },
					onLoadPool: loadPoolByFront({
						prm: PrmCommonParams,
						ui,
						runtime: this.props.runtime,
					}),
					onClickTab: (i: number) => {
						replaceUrlWithTag(header.position, tagGroup[i]?.text.content);
					},
					SetCtrTrackOnAction: (pos: string, pid: string) =>
						SetLitbCtrTrackOnAction({ cpid: pid, pos }),
					SetCtrTrackOnShow: (pos: string, pids: string[] = []) => {
						SetLitbCtrTrackOnShow({ pids: pids.join(","), pos });
					},
				};
				if (isRollable) {
					return (
						<WebSlideProduct
							{...modProps}
							width={1190}
							minWidth={1190}
							posterRatio={posterRadio}
						/>
					);
				}
				return <WebProduct {...modProps} posterRatio={posterRadio} />;
			case TModuleType.TCoupon:
				const cpoponModule: TCouponGroupModule = moduleData;
				const { languageCode, currency, countryCode3 } = this.props.runtime;
				const props = {
					...modProps,
					spmClick: (order: string) => {
						sendPrm({
							site: getSite(),
							page: "65",
							part: index + 1,
							content: order + 1,
						});
					},
					coupons: tranformCouponInfo(cpoponModule?.coupons),
					type: item?.module?.couponType || CouponType.ReceiveCoupon,
					getCoupons: (code: string): Promise<any> => {
						if (!!!this.props.runtime?.sessionZeusKey) {
							jumpToLogin();
						}
						return getGetCoupons(
							{
								client: "vela_pc",
								isUat: isUAT() ? "true" : undefined,
								campaign_key: code,
								sid: this.props.runtime.sid,
								sessionkey: this.props.runtime?.sessionZeusKey || "",
								language: languageCode,
								currency,
								country: countryCode3,
							},
							false,
						);
					},
					columnSize: item.layout.columnNum,
				};
				return <CouponCode {...props} />;
			default:
				return null;
		}
	};

	render() {
		const { modules } = this.props;
		return (
			<React.Fragment>
				{modules.map((item, index) => {
					return this.renderComponents(item, index);
				})}
			</React.Fragment>
		);
	}
}
